import { TRENDING } from '../constants';
import { HotDealsAndTrendingProps } from '../types';
import LinkItem from '../LinkItem';
import HotDeals from './HotDeals';
import i18n from '@/settings/i18n';

const t = i18n.init('shared');

const HotDealsAndTrending = ({ closeMenu }: HotDealsAndTrendingProps) => (
  <section>
    {/* Hot Deals Banner  */}
    <HotDeals closeMenu={closeMenu} />
    {/* Trending Section */}
    <h2 className="flex h-10 items-center p-5 text-base font-bold">{t`Trending`}</h2>
    {TRENDING.map((item) => (
      <LinkItem
        key={item.pk}
        title={t(item.name)}
        handle={item.handle}
        closeMenu={closeMenu}
      />
    ))}
  </section>
);

export default HotDealsAndTrending;
